import React, { useState } from 'react';
// import {
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions
// } from "@material-ui/core";

import { cropImage } from "./cropUtils";
import Cropper from "react-easy-crop";
// import CloseIcon from '@material-ui/icons/Close';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Icon } from '@mui/material';
import { Close } from '@mui/icons-material';
// import IconButton from '@material-ui/core/IconButton';

const ImageCropper = ({
  open,
  handleClose,
  image,
  userId,
  onComplete,
  containerStyle,
  ...props
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <div className="d-flex justify-content-between align-items-center">
        <DialogTitle>
          Crop Image
        </DialogTitle>
        <Icon aria-label="close" onClick={handleClose}>
          <Close />
        </Icon>
      </div>

      <DialogContent>
        <div style={containerStyle}>
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onCropComplete={(_, croppedAreaPixels) => {
              setCroppedAreaPixels(croppedAreaPixels);
            }}
            onZoomChange={setZoom}
            {...props}
          />
        </div>
      </DialogContent>

      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            onComplete(cropImage(image, croppedAreaPixels, console.log))
          }}
        >
          Finish
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageCropper